import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import {IClauseExtensionMySuffix} from 'src/app/shared/model/clause-extension-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {Principal} from './../../core/auth/principal.service';
import {IPolicyMySuffix} from './../../shared/model/policy-my-suffix.model';
import {IScopeMySuffix} from './../../shared/model/scope-my-suffix.model';


@Component({
    selector: 'jhi-clause-extension-my-suffix-detail',
    templateUrl: './clause-extension-my-suffix-detail.component.html'
})
export class ClauseExtensionMySuffixDetailComponent implements OnInit {
    @ViewChild('policyModal') policyModal: ModalDirective;

    clauseExtension: IClauseExtensionMySuffix;

    fileName: any;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;

    policyData: IPolicyMySuffix[]=[];

    public readonly RoleUtil = RoleUtil;

    constructor(
        private jhiAlertService: JhiAlertService,
        private activatedRoute: ActivatedRoute,
        private principal: Principal,
        private clauseExtensionMySuffixService: ClauseExtensionMySuffixService,
        private languageChangeService: LanguageChangeService,
        private router: Router,
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
    });
     }

    ngOnInit() {
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ clauseExtension }) => {
            this.clauseExtension = clauseExtension;
            console.log('CLAUSE AND EXTENSION ::;@@@ ::: ', this.clauseExtension);
            console.log('CLAUSE AND EXTENSION ::;@@@ ::: ', this.clauseExtension.fileDTO.fileId);
        });
    }

    previousState() {
        window.history.back();
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    downloadFile() {

        if (!this.clauseExtension.fileDTO.fileId) {
            return;
        }
        this.clauseExtensionMySuffixService.downloadFileService(this.clauseExtension.fileDTO.fileId).subscribe(
            response => {
                this.createPdfFromBlob(response);
            },
            err => {
                console.log(err);
                let mesg = "The document could not be found";
                this.jhiAlertService.error(mesg);
            }
        );
    }

    createPdfFromBlob(pdf: Blob) {
        let reader = new FileReader();
        reader.addEventListener('load', () => { }, false);
        if (pdf) {
            this.fileName = this.clauseExtension.fileDTO.name;
            reader.readAsArrayBuffer(pdf);
            let fileURL = URL.createObjectURL(pdf);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = this.fileName;
            link.click();
            window.URL.revokeObjectURL(fileURL);
        }
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    
    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) { //Future Records
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Clause Extensions (' + Obj.name + ') Future Records';
        this.historyType = "CLAUSE_EXTENSION_AUDIT";
        this.historyId = Obj.id;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Clause Extensions (' + Obj.name + ') History';
        this.historyType = "CLAUSE_EXTENSION_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    openPolicyInfoModel(id) {
        this.policyData=this.clauseExtension.policies;
        this.policyModal.show();
    }

    hidePolicyModal() {
        this.policyModal.hide();
    }

    openScopePage(scope: IScopeMySuffix,policy: IPolicyMySuffix) {
        localStorage.setItem('policyId',JSON.stringify(policy.id));
        let url;
        if(policy.editPermission) {
             url = this.router.serializeUrl(this.router.createUrlTree(['/scope-my-suffix',scope.id,'view']))
        } else {
             url = this.router.serializeUrl(this.router.createUrlTree(['/scope-my-suffix/open-policy-scope-my-suffix', scope.id, 'view' ]))
        }
        window.open(url,'_blank');
    }
}
